module.exports = __webpack_public_path__ + "static/flags/AN-f45e8f48f1b67df7b1c120582b48f34d.gif";